var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", [
      _c("div", { staticClass: "headerpanel" }, [
        _vm.showMenuLeft
          ? _c("div", { staticClass: "logopanel" }, [_vm._m(0)])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "headerbar",
            class: { "margin-zero": !_vm.showMenuLeft }
          },
          [
            _c(
              "a",
              {
                staticClass: "menutoggle",
                on: {
                  click: function($event) {
                    return _vm.onToggleMenu()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-bars" })]
            ),
            _c("div", { staticClass: "header-right" }, [
              _vm.userInfo.userId > 0 && _vm.isToken
                ? _c("ul", { staticClass: "headermenu" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-notice",
                              class: { "alert-notice": _vm.totalNotify > 0 },
                              attrs: {
                                "data-toggle": "dropdown",
                                "aria-expanded": "false"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-bell",
                                attrs: { "data-total": _vm.totalNotify }
                              })
                            ]
                          ),
                          [
                            _c("notification", {
                              on: {
                                totalNotification: function($event) {
                                  return _vm.getTotalNotification($event)
                                }
                              }
                            })
                          ]
                        ],
                        2
                      )
                    ]),
                    _c("li", [
                      _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-logged",
                            attrs: { type: "button", "data-toggle": "dropdown" }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "assets/images/photos/loggeduser.png",
                                alt: ""
                              }
                            }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.userInfo.userName) +
                                "\n                                "
                            ),
                            _c("span", { staticClass: "caret" })
                          ]
                        ),
                        _c("ul", { staticClass: "dropdown-menu pull-right" }, [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "profile" } } },
                                [_vm._v("Thông tin tài khoản")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "order" } } },
                                [_vm._v("Quản lý đơn hàng")]
                              )
                            ],
                            1
                          ),
                          _c("li", [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript: void(0)" },
                                on: { click: _vm.onLogout }
                              },
                              [_vm._v("Thoát")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://happyorder.vn"
        }
      },
      [
        _c("img", {
          attrs: { src: "assets/images/logo/logo-dark.png", alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }